import { mq, spacing, styled, Text } from '@thg-commerce/gravity-theme'
import { Image, SafeHtml } from '@thg-commerce/gravity-elements'

export const Description = styled(SafeHtml)`
  ${Text('bodyText', 'default')}
  margin-top: ${spacing(2)};
  margin-bottom: ${spacing(3)};
  color: ${(props) => props.theme.colors.palette.greys.dark};

  p {
    color: inherit;
  }
`

export const StyledImage = styled(Image)`
  margin-bottom: ${spacing(3)};
`

export const Container = styled.div<{
  direction?: 'row' | 'row-reverse' | 'column' | 'column-reverse'
  onlyDisplayOfferBadge?: boolean
  reduceBottomMargin?: boolean
  border?: { width: string; type: string }
}>`
  display: flex;
  flex-direction: column;

  ${(props) =>
    props.onlyDisplayOfferBadge &&
    `
     ${
       props.border &&
       `border: ${props.border.width} ${props.border.type} ${props.theme.colors.system.pap.border}`
     };
      margin-bottom: ${props.reduceBottomMargin ? '0' : spacing(2)};
    `}

  ${(props) =>
    props.direction === 'row' &&
    `
      ${mq(props.theme.breakpointUtils.map, 'sm')} {
        flex-direction: row;
      }
    `}
`

export const FreeGiftTitle = styled.div`
  ${Text('bodyText', 'alternate')}
  margin-top: ${spacing(1)};
  margin-bottom: ${spacing(1)};
`

export const FreeGiftPrices = styled.div`
  ${Text('bodyText', 'alternate')}
  margin-top: ${spacing(1)};
  margin-bottom: ${spacing(3)};
`
